import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { RevealLines } from "@/components/site/Reveal";
import { MEDIA, COMPANY } from "@/lib/assets";
import { ArrowDown } from "lucide-react";

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "35%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.15]);
  const overlayOpacity = useTransform(scrollYProgress, [0, 1], [0.55, 0.8]);

  return (
    <section ref={ref} data-testid="hero-section" className="relative min-h-screen flex flex-col justify-end overflow-hidden">
      <motion.div style={{ y, scale }} className="absolute inset-0 z-0">
        <img src={MEDIA.warehouseRolls} alt="Paper rolls" className="w-full h-[120%] object-cover" />
      </motion.div>
      <motion.div style={{ opacity: overlayOpacity }} className="absolute inset-0 z-10 bg-foreground" />

      <div className="relative z-20 mx-auto max-w-[1400px] w-full px-5 md:px-10 pb-16 md:pb-24">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 1 }}
          className="font-mono2 text-xs md:text-sm uppercase tracking-[0.3em] text-background/80 mb-6"
        >
          {COMPANY.short} — Paper ordering now simplified
        </motion.p>

        <h1 className="font-display text-background text-[15vw] md:text-[10vw] leading-[0.9] tracking-tight">
          <RevealLines lines={["The supply chain", "behind paper &", "paperboard."]} delay={0.35} />
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.1, duration: 0.8 }}
          className="mt-10 flex flex-col md:flex-row md:items-end justify-between gap-8"
        >
          <p className="text-background/85 max-w-md text-base md:text-lg leading-relaxed">
            Authorised dealers and quick sheet-cutting specialists for FBB/SBS, C2S coated and recycled boards —
            serving manufacturers across India from our West-zone hubs in Bhiwandi and Ahmedabad.
          </p>
          <div className="flex items-center gap-3 text-background/70 font-mono2 text-xs uppercase tracking-[0.2em]">
            <ArrowDown size={16} className="animate-bounce" />
            Scroll to explore
          </div>
        </motion.div>
      </div>
    </section>
  );
};
